const advisorCourseFlagdialogState = {
  resolve: {
    genericSlot: ($stateParams: ng.ui.IStateParamsService) => $stateParams.genericSlot
  },
  views: {
    'modal@ap-advisor': {
      template: `<course-flag-dialog generic-slot="$resolve.genericSlot"></course-flag-dialog>`
    }
  },
  data: {
    pageTitle: 'Flag course'
  },
  params: {
    genericSlot: null
  }
};

export const ApAdvisorFlagCourseDetailRoutes = {
  'ap-advisor.plan.edit.default.course_flag_dialog': { ...advisorCourseFlagdialogState },
  'ap-advisor.plan.edit.coursegroup.course_flag_dialog': { ...advisorCourseFlagdialogState }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/advisor_routes/planner/ap_advisor_flag_course_popup_routes.ts